import { ExamOptionDetails } from "src/components/NewComponents/Exam/OptionDetails/ExamOptionDetails";
import { ExamOptionsList } from "src/components/NewComponents/Exam/OptionsList/ExamOptions";

export function ExamOptions() {
	return (
		<>
			<ExamOptionsList />
			<ExamOptionDetails />
		</>
	);
}
